blue.ready('rotaryTab', '.rotaryTab', rotary => {
	const tabs = [...rotary.querySelectorAll('.rotaryTab-tab')]
	const contents = [...rotary.querySelectorAll('.rotaryTab-content')]
	const imgCont = rotary.querySelector('.rotaryTab-images')
	let images = [...rotary.querySelectorAll('.rotaryTab-image')]
	let current = 0

	const rotate = function() {
		let _this = images.filter(img => img.matches(`[data-tab="${this.getAttribute("data-tab")}"]`))[0]

		if (!_this.classList.contains('is-active')) {
			images = [...rotary.querySelectorAll('.rotaryTab-image')]
			images.forEach(img => img.classList.remove('is-active'))
			current = images.indexOf(_this)

			//select active tab
			tabs.forEach(tab => tab.classList.remove('is-active'));
			tabs.forEach(tab => {
				if (tab.matches(`[data-tab="${_this.getAttribute("data-tab")}"]`)) {
					tab.classList.add('is-active')
				}
			})

			//select active content
			contents.forEach(content => content.classList.remove('is-active'));
			contents.forEach(content => {
				if (content.matches(`[data-tab="${_this.getAttribute("data-tab")}"]`)) {
					content.classList.add('is-active')
				}
			})

			//rotate images D:
			//first
			images.forEach(img => img._startPosTop = img.getBoundingClientRect().top)
			images.forEach(img => img._startPosLeft = img.getBoundingClientRect().left)

			if (images.indexOf(_this) == 3) {
				imgCont.insertAdjacentElement('afterbegin', images[current])
			}
			else if (images.indexOf(_this) == 2) {
				imgCont.insertAdjacentElement('afterbegin', images[current + 1])
				imgCont.insertAdjacentElement('afterbegin', images[current])
			}
			else if (images.indexOf(_this) == 1) {
				imgCont.insertAdjacentElement('afterbegin', images[current + 2])
				imgCont.insertAdjacentElement('afterbegin', images[current + 1])
				imgCont.insertAdjacentElement('afterbegin', images[current])
			}

			//last
			images.forEach(img => img._endPosTop = img.getBoundingClientRect().top)
			images.forEach(img => img._endPosLeft = img.getBoundingClientRect().left)

			//invert
			images.forEach(img => {
				img.style.transform = `
					translate(
						${img._startPosLeft - img._endPosLeft}px, 
						${img._startPosTop - img._endPosTop}px
					)`
			})
			images.forEach(img => img.getBoundingClientRect())
			images.forEach(img => {
				img.style.transition = '0.5s ease'
				if (img == _this) {
					img.classList.add('is-active')
				}
			})
			images.forEach(img => img.getBoundingClientRect())
			//play 
			images.forEach(img => {
				if (img == _this && blue.prop.media.default.matches) {
					img.style.transform = 'translate(0,0) scale(1.5,1.5)'
				}
				else {
					img.style.transform = 'translate(0,0)'
				}
				setTimeout(() => {
					img.style.transition = ''
					img.style.transform = ''
				}, 500)
			})
		}
	}

	images.forEach(img => img.addEventListener('click', rotate))
	tabs.forEach(tab => tab.addEventListener('click', rotate))
}) 